module.exports = __webpack_public_path__ + "static/media/hands_05.84164088.svg";